import * as React from 'react';
import { DateInput } from '../DateInput/DateInput';
import { Icon } from '../Icon/Icon';

export type NewsArchiveFilterState = {
    searchtext?: string;
    datefrom?: string;
    dateto?: string;
};

export interface INewsArchiveFilterProps {
    searchtext: string;
    datefrom: string;
    dateto: string;
    onUpdate: (data: NewsArchiveFilterState) => void;
}

export const NewsArchiveFilter: React.FC<INewsArchiveFilterProps> = ({ searchtext, datefrom, dateto, onUpdate }) => {
    const handleReset = () => {
        onUpdate({ datefrom: '', dateto: '' });
    };

    return (
        <section className="col-12" aria-label="Filtreringsval för nyheter">
            <form autoComplete="off" className="traffic-info__filter" onSubmit={(e) => e.preventDefault()}>
                <div className="d-flex traffic-info__standard-filter">
                    <label className="visually-hidden" htmlFor="news-searchtext">
                        Sök nyheter
                    </label>
                    <div className="input-group traffic-info__search">
                        <div className="input-group-text">
                            <Icon symbol="icon-search" className="input-group-icon" />
                        </div>
                        <input
                            id="news-searchtext"
                            className="form-control"
                            type="search"
                            placeholder="Sök nyheter"
                            name="searchtext"
                            value={searchtext}
                            onChange={(event) => onUpdate({ searchtext: event.target.value })}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-link text-nowrap traffic-info__filter-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#newsarchive-filter-choices"
                        aria-expanded="false"
                        aria-controls="newsarchive-filter-choices"
                    >
                        Visa datumfilter
                        <i className="icon-animated icon-up-open" aria-hidden="true" />
                    </button>
                </div>
                <div id="newsarchive-filter-choices" className="collapse">
                    <div className="traffic-info pt-3">
                        <div className="traffic-info__filter-list">
                            <div className="traffic-info__date">
                                <div className="traffic-info__heading traffic-info__date-heading">Datumintervall:</div>
                                <div className="news-archive-filter__date-range">
                                    <div className="news-archive-filter__date-field">
                                        <label className="traffic-info__label" htmlFor="newsarchive-datefrom">
                                            Från:
                                        </label>
                                        <DateInput
                                            className="form-control"
                                            id="newsarchive-datefrom"
                                            name="datefrom"
                                            value={datefrom}
                                            max={dateto}
                                            onChange={(date) => onUpdate({ datefrom: date })}
                                        />
                                    </div>
                                    <div className="news-archive-filter__date-field">
                                        <label className="traffic-info__label" htmlFor="newsarchive-dateto">
                                            Till:
                                        </label>
                                        <DateInput
                                            className="form-control"
                                            id="newsarchive-dateto"
                                            name="dateto"
                                            value={dateto}
                                            min={datefrom}
                                            onChange={(date) => onUpdate({ dateto: date })}
                                        />
                                    </div>
                                    <div className="news-archive-filter__small-info">(Visar nyheter som publicerats mellan valda datum)</div>
                                    <button
                                        type="button"
                                        className="btn btn-dark btn-block traffic-info__cancel news-archive-filter__reset"
                                        onClick={handleReset}
                                    >
                                        <i className="icon-cancel" aria-hidden="true" />
                                        Återställ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    );
};
